import { useEffect, useState } from "react";
import { toast } from "sonner";
import { X } from "lucide-react";
import { endpoints } from "@/lib/api";
import { Field, Btn, handleErr } from "./AdminUI";
import { ImageUpload } from "@/components/ImageUpload";

// Writer's own byline (photo + role) shown in the author card at the end of every story they write.
export const WriterProfile = ({ onClose }) => {
  const [f, setF] = useState(null);
  useEffect(() => {
    let alive = true;
    endpoints.myByline().then((r) => { if (alive) setF((cur) => cur || r.data); }).catch(handleErr);
    return () => { alive = false; };
  }, []);
  const save = async () => {
    try { await endpoints.setMyByline({ photo: f.photo, role: f.role }); toast.success("Writer profile saved"); onClose(); } catch (e) { handleErr(e); }
  };
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="writer-profile-modal">
      <div className="absolute inset-0 bg-black/70" onClick={onClose} />
      <div className="relative w-full max-w-md rounded-2xl bg-[#121620] border border-[#273042] p-6 grid gap-3">
        <div className="flex items-center justify-between"><h3 className="text-lg font-bold text-white">My writer profile</h3><button onClick={onClose} aria-label="Close"><X className="w-5 h-5 text-slate-400" /></button></div>
        <p className="text-xs text-slate-400 -mt-1">Readers see this at the end of every story you write{f?.name ? ` as ${f.name}` : ""}.</p>
        {f && <>
          <ImageUpload label="Your photo" value={f.photo} onChange={(url) => setF({ ...f, photo: url })} testid="writer-photo" aspect="aspect-square max-w-[160px]" />
          <Field label="Your role / title" placeholder="e.g. Sports Journalist" value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} data-testid="writer-role-input" />
          <Btn onClick={save} data-testid="writer-profile-save">Save profile</Btn>
        </>}
      </div>
    </div>
  );
};
